module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/namba_sns_02-1fb57d8fa38f6e8e25c2ebc51336a385.jpg";